import {useContext} from 'react'

import Context from '@s-ui/react-context'

import {CRITEO_EVENTS, TRACK_EVENTS, TRACK_PAGE_EVENTS} from './config.js'
import useCriteoConfig from './useCriteoConfig.js'
import {getCriteoEventData} from './utils.js'

export const useCriteoData = () => {
  const {domain} = useContext(Context)
  const {config} = useCriteoConfig()

  const {CRITEO_ACCOUNT_ID, CRITEO_VENTA_ACCOUNT_ID} = domain.get('config').get('tracking')

  const getCriteoEventAccountId = ({event}) => {
    switch (event) {
      case TRACK_PAGE_EVENTS.AD_INSERTED:
      case TRACK_PAGE_EVENTS.INSTANT_OFFER_STANDALONE:
      case TRACK_PAGE_EVENTS.INSTANT_OFFER_APPOINTMENT_CONFIRMED:
      case TRACK_PAGE_EVENTS.PTA_CAR_CATEGORY:
      case TRACK_PAGE_EVENTS.STANDALONE_SELECTION:
      case TRACK_PAGE_EVENTS.VIEW_INSTANT_OFFER_FROM_STANDALONE:
        return CRITEO_VENTA_ACCOUNT_ID
      default:
        return CRITEO_ACCOUNT_ID
    }
  }

  /**
   * According to Criteo Confluence docs.
   * https://confluence.mpi-internal.com/display/ST/Criteo
   */
  const getCriteoData = async ({event, eventData = {}}) => {
    const {customerId, hashedEmail, hashMethod, siteType} = await config

    const emailEventName = hashedEmail ? TRACK_EVENTS.SET_HASHED_EMAIL : TRACK_EVENTS.SET_EMAIL

    const accountEventData = {
      event: TRACK_EVENTS.SET_ACCOUNT,
      account: getCriteoEventAccountId({event})
    }
    const siteEventData = {
      event: TRACK_EVENTS.SET_SITE_TYPE,
      type: siteType
    }
    const emailEventData = {
      event: emailEventName,
      email: hashedEmail,
      ...(hashedEmail && {hash_method: hashMethod})
    }
    const customerEventData = {
      event: TRACK_EVENTS.SET_CUSTOMER_ID,
      id: String(customerId)
    }

    const baseData = [accountEventData, emailEventData, siteEventData, customerId && customerEventData]

    const optionalEventData = {
      event: CRITEO_EVENTS[event] || event,
      ...getCriteoEventData({event, eventData})
    }

    const criteoData = [...baseData, optionalEventData].filter(Boolean)

    return {criteoData}
  }
  return {getCriteoData}
}
